Apt.fn.make('search', {
	/**
	 * Initialize module
	 *
	 * @returns {Object}
	 */
	init: function() {
		this.$private.setup();
	},

	/**
	 * Collapse results
	 */
	collapse: function() {
		this.$private.collapse();
	},

	/**
	 * Focus the search input
	 */
	focus: function() {
		this.$private.$input.focus();
	},

	/**
	 * Blur the search input
	 */
	blur: function() {
		this.$private.$input.blur();
	},

	/**
	 * Clear input values
	 */
	clear: function() {
		var priv = this.$private;

		priv.current = null;

		if (priv.app) { // Check if app exists (for header search)
			priv.app.$drop('value');
		}
		if (priv.$input) {
			priv.$input.val('');
		}
	},

	/**
	 * Unload module and cleanup
	 */
	unload: function() {
		var priv = this.$private;

		if (priv.app) {
			priv.app.$destroy();
		}
		if (priv.resultsApp) {
			priv.resultsApp.$destroy();
		}
		if (priv.paginationApp) {
			priv.paginationApp.$destroy();
		}

		// Clean up event bindings
		if (priv.$target && priv.$target.length) {
			priv.$target.off();
		}
		if (priv.$input && priv.$input.length) {
			priv.$input.off();
		}

		// Clean up pagination events
		$.events.reset('pagination');

		// Reset initialization flag
		priv.generalInitialized = false;
	}
}, {
    credentials: fetch('/nocache/algolia').then(res => res.json()),

	/**
	 * Generate target elements and create application
	 */
	setup: function() {
		var scope = this;

		// Prevent duplicate general initialization
		if (!scope.generalInitialized) {
			scope.generalInitialized = true;

			scope.conf = {
				namespace: 'search-' + new Date().getTime()
			};

			// Common setup for header search input, if present
			scope.$target = $$('searchForm');
			if (scope.$target.length) {
				scope.$input = $('input', scope.$target);
			}

			if (scope.$target.length && scope.$input.length) {
				scope.$results = $('<div class="header-search__content"/>');
				scope.current = null; // Used by header search logic
				scope.$target.append(scope.$results);
				scope.app = $.app.make(scope.conf.namespace + '-header', {
					target: scope.$results,
					view: 'search.results',
					model: {
						id: scope.conf.id,
						name: 'search-header'
					}
				});

				scope.bindEvents();
			}
		}

		// Always check for search page initialization
		if ($.routes.uri().path === '/results') {
			scope._initFullResultsPage();
		}
	},

	/**
	 * Initialize full search results page
	 */
	_initFullResultsPage: function() {
		var scope = this;
		var keywords = $.routes.uri().query.keywords;
		var page = parseInt($.routes.uri().query.page || '1', 10); // Convert to 0-indexed for Algolia
		var algoliaPage = Math.max(0, page - 1);

		// Ensure history module is initialized for PJAX navigation
		if (!$.history.request) {
			$.history.init({
				partials: 'title, main',
				push: true,
				run: true
			});
		}

		// Bind history events for the results page to enable PJAX navigation
		// but exclude pagination links from automatic binding
		$.history.bind(true, {}, 'body > *:not([data-ref="search-results"])');

		// Populate the search input with the keywords from URL
		if (keywords && scope.$input && scope.$input.length) {
			scope.$input.val(decodeURIComponent(keywords.replace(/\+/g, ' ')));
		}

		var $resultsContainer = $$('search-results'); // Using $$() for data-ref
		if (!$resultsContainer.length) {
			return;
		}

		// Always clear the container first
		$resultsContainer.empty();

		if (keywords) {
			// Add loading indicator
			$resultsContainer.html('<div class="search-loading"></div>');

			scope.query({
				keywords: keywords,
				context: 'fullPage',
				hitsPerPage: 20, // Default for full page
				page: algoliaPage
			});
		} else {
			// No keywords, render empty results directly (container is already empty)
			scope._renderFullPageResults({ hits: [], nbHits: 0, page: 0, nbPages: 0 });
		}
	},

	/**
	 * Render full page results using template
	 * @param {Object} algoliaData - Algolia response data, e.g., { hits, nbHits, page, nbPages }
	 */
	_renderFullPageResults: function(algoliaData) {
		var scope = this;
		var $resultsContainer = $$('search-results');
		if (!$resultsContainer.length) return;

		// Completely clear the results container. This will remove the loading indicator
		// and any previous results or pagination.
		$resultsContainer.empty();

		// If a resultsApp instance already exists, destroy it and nullify the reference.
		// This is done before processing new data for a new app instance.
		if (scope.resultsApp) {
			scope.resultsApp.$destroy();
			scope.resultsApp = null;
		}

		// Remove loading state
		$resultsContainer.removeClass('-is-fetching');

		var hits = algoliaData.hits || [];
		var currentPage = algoliaData.page || 0;
		var totalPages = algoliaData.nbPages || 0;

		// Transform Algolia hits to match catalog template structure
		var transformedResults = hits.map(function(hit) {
			return scope._transformAlgoliaHit(hit);
		});

		// Create model for template, accommodating potential error messages
		var model = {
			results: transformedResults,
			emptyTitle: algoliaData.message ? 'Search Error' : 'No Results Found',
			emptyMessage: algoliaData.message || 'Please try different search terms.',
			// Keep track of whether there was an error to potentially display differently in template
			isError: !!algoliaData.message
		};

		// Always create a new target div and a new app instance for the results.
		var $target = $('<div />');
		$resultsContainer.append($target); // Append the new target for the app.

		scope.resultsApp = $.app.make(scope.conf.namespace + '-results', {
			target: $target,
			view: 'search.full_results',
			model: model
		});

		// Highlight wishlist items after results are rendered
		Apt.wishlists.highlight();

		// Handle pagination if there are multiple pages
		if (totalPages > 1) {
			scope._renderPagination({
				current_page: currentPage + 1, // Convert to 1-indexed for display
				total_pages: totalPages,
				keywords: $.routes.uri().query.keywords
			});
		} else {
			// If there are no longer multiple pages (e.g., new search query returns fewer results),
			// ensure any existing pagination controls are removed.
			$resultsContainer.find('.pagination').remove();
		}
	},


	/**
	 * Bind result, input, and body events (for header search)
	 */
	bindEvents: function() {
		var scope = this,
			$input = scope.$input,
			// Use the header-specific app namespace for these events
			namespace = scope.app ? scope.app.namespace : scope.conf.namespace + '-headerEvents',
			cancel = false,
			down = false;

		if (!scope.$target || !scope.$input) return; // Don't bind if header search elements aren't there

		scope.$target.on('submit', function() {
			// Navigate to full results page
			$.history.go('/results?keywords=' + $input.val(), {
			    force: true,
			});
		}, {
			cancel: true,
			namespace: namespace
		});

		// Attach click events to result entries for header dropdown
		$($._body).on({
			click: function(e) {
				down = e.target;
				scope.collapse(); // Collapse header dropdown
			},
			mousedown: function(e) {
				down = e.target;
			}
		}, {
			delegate: scope.$results, // scope.$results is the header dropdown container
			namespace: namespace
		});

		// Bind primary result events for header input
		$input.on({
			click: function() {
				if (!scope.active) { // scope.active relates to header dropdown
					$input.trigger('focus');
				}
			},
			focus: function() {
				scope.$target.addClass('-is-active'); // For header search
				scope.process(null, this.value); // Process for header search
			},
			blur: function() { // For header search
				if (!down || !scope.$target.contains(down)) {
					scope.$prev = false;
					if (this.value) {
						if (scope.$entries && scope.$entries.length && scope.app) {
							scope.app.$set('value', scope.app.$get('results.0'));
						}
					} else if (scope.app) {
						scope.app.$drop('value');
					}
					scope.collapse();
				}
			},
			keydown: function(e) { // For header search
				var key = e.code;

				cancel = false;

				if (key === 'ArrowDown' || key === 'ArrowUp') {
				    e.preventDefault();
				} else if (key === 'Enter') {
					cancel = true;
					scope.action();
				} else if (key === 'Tab' || key === 'Escape') {
					cancel = true;
					scope.collapse();
				} else if ((e.ctrlKey || e.metaKey) && key !== 'KeyV') {
					cancel = true;
				}
			},
			keyup: function(e) { // For header search
				if (!cancel) {
					scope.process(e.keyCode, this.value);
				}
				e.preventDefault();
				e.stopPropagation();
			}
		}, {
			namespace: namespace
		});
	},

	/**
	 * Collapse the visible result list (for header search)
	 */
	collapse: function() {
		var scope = this;
		delete scope.active;
		delete scope.$active;
		delete scope.$entries;
		scope.flush(); // Clears pending header search requests
		if (scope.visible) { // scope.visible relates to header dropdown
			if (scope.app) { // Check if app (header app) is initialized
				$($._body).off('click.' + scope.app.namespace);
			}
			scope.hide(); // Hides header dropdown
		}
	},

	/**
	 * Process the keyup event for evaluation (for header search)
	 */
	process: function(key, value) {
		var scope = this;
		scope.active = true; // For header dropdown state
		if (scope.$active) { scope.$active.removeClass('-is-active'); }

		if (key === 40 || key === 38) { // Arrow navigation for header dropdown
			if (scope.$active) {
				var $active = scope.$active;
				$active = key === 40 ? $active.next() : $active.prev();
				if ($active.length) { scope.$active = $active; }
			} else if (scope.$entries && scope.$entries.length) {
				scope.$active = key === 40 ? scope.$entries.first() : scope.$entries.last();
			} else {
				scope.$active = null;
			}
			if (scope.$active) { scope.$active.addClass('-is-active'); }
		} else if (value.length >= 3 || !value) { // Trigger header search query
			if (key !== 32) { scope.flush(); }
			scope.pending = setTimeout(function() {
				scope.clearPending(); // Renamed from scope.clear to avoid conflict with public clear
				scope.query({ keywords: value, context: 'header' });
			}, value ? 350 : 0);
		}
	},

	/**
	 * Flush pending operations (for header search)
	 */
	flush: function() {
		this.clearPending();
		// Abort only header search requests, check if app (header app) exists
		if (this.app) {
			$.fetch.abort(this.app.namespace);
		}
	},

	/**
	 * Clear pending requests (for header search) - Renamed from 'clear'
	 */
	clearPending: function() {
		clearTimeout(this.pending);
		this.pending = null;
	},

	/**
	 * Query API for search results.
	 * @param {Object} options - { keywords, context ('header'|'fullPage'), hitsPerPage, page }
	 */
	query: async function(options) {
		var scope = this,
			keywords = options.keywords,
			context = options.context || 'header',
			hitsPerPage = options.hitsPerPage,
			page = options.page || 0; // Algolia pages are 0-indexed

		const { appId, apiKey } = await scope.$private.credentials

		// `algoliaKey` is used for transform for header only
		var algoliaKey = (scope.conf.type || '') + (scope.conf.type || '');

		if (context === 'header') {
			if (keywords) {
				keywords = keywords.trim();
				if (keywords === scope.previous) { // scope.previous is for header context
					scope.show(); // Show header dropdown
					return;
				}
			}
			scope.previous = keywords; // Set for header context
			scope.$active = null; // Reset active item in header dropdown
		}

		var fetchNamespace = context === 'fullPage'
		    ? scope.conf.namespace + '-fullPage'
			: (scope.app ? scope.app.namespace : scope.conf.namespace + '-headerQuery');

		var algoliaRequestOptions = {
			url: 'https://' + appId.toLowerCase() + '-dsn.algolia.net/1/indexes',
			json: true,
			method: 'post',
			data: { apiKey: apiKey, appID: appId },
			namespace: fetchNamespace
		};

		// Build the same request structure for both contexts
		var requests = [];
		var encoded = encodeURIComponent(keywords || '');

		if (!keywords) {
			if (context === 'header') {
				// Empty input for header: show default/recent
				var recentResults = $$('searchForm').data('results');
				if (recentResults && recentResults.length) {
					var headerLimit = scope.getLimit();
					recentResults = recentResults.slice(0, headerLimit);
					algoliaRequestOptions.url += '/*/objects';
					algoliaRequestOptions.data.requests = recentResults.map(function(id) {
						return {
						    indexName: $.env() === 'prod' ? 'product' : 'default',
							objectID: id.toString(),
						};
					});
					algoliaRequestOptions.success = function(data) {
						scope.transform(algoliaKey, keywords, {
							total: data.results.length,
							results: data.results,
						});
					};
				} else { // No recent results to show, clear dropdown
					if (scope.app) scope.app.$merge({message: false, more: false, results: null});
					return; // Don't make a request
				}
			} else { // fullPage with no keywords
				scope._renderFullPageResults({ hits: [], nbHits: 0, page: page, nbPages: 0 });
				return;
			}
		} else {
			// Use single unified query for both contexts
			var resultsPerPage = context === 'fullPage' ? (hitsPerPage || 20) : 50;
			var searchPage = context === 'fullPage' ? page : 0; // Header always uses page 0

			// Single query to product index which should contain both products and series
			requests.push({
			    indexName: $.env() === 'prod' ? 'product' : 'default',
				params: 'query=' + encoded + '&hitsPerPage=' + resultsPerPage + '&page=' + searchPage,
			});

			algoliaRequestOptions.url += '/*/queries';
			algoliaRequestOptions.data.requests = requests;

			if (context === 'fullPage') {
				algoliaRequestOptions.success = function(data) {
					// Process single unified search result
					var result = data && data.results && data.results[0];
					var responseData = {
						hits: result?.hits || [],
						nbHits: result?.nbHits || 0,
						page: result?.page || page,
						nbPages: result?.nbPages || 0
					};

					// Ensure all hits have a type field (default to 'product' if not specified)
					if (responseData.hits) {
						responseData.hits = responseData.hits.map(function(hit) {
							if (!hit.type) {
								hit.type = 'product'; // Default type
							}

							return hit;
						});
					}

					scope._renderFullPageResults(responseData);
				};

				algoliaRequestOptions.error = function() {
					scope._renderFullPageResults({
						hits: [],
						nbHits: 0,
						message: "Error fetching results.",
						page: page,
						nbPages: 0,
					});
				};
			} else { // header context
				algoliaRequestOptions.success = function(data) {
					var result = data && data.results && data.results[0];
					var hits = result ? result.hits || [] : [];
					var total = result ? result.nbHits || 0 : 0;

					// Slice to header limit (first 4 results)
					var headerLimit = scope.getLimit();
					var limitedResults = hits.slice(0, headerLimit);
					scope.transform(algoliaKey, keywords, {
						total: limitedResults.length,
						more: total > headerLimit,
						results: limitedResults
					});
				};
			}
		}

		$.fetch.request(algoliaRequestOptions);
	},

	/**
	 * Transform Algolia hit to match catalog template structure
	 * @param {Object} hit - Algolia hit object
	 * @returns {Object} - Transformed object for template
	 */
	_transformAlgoliaHit: function(hit) {
		var transformed = {
			id: hit.objectID,
			objectID: hit.objectID,
			title: hit.type.handle === 'series'
			    ? `${hit.title} Series`
				: hit.title,
			model: hit.model || '',
			series: hit.series || hit.label || '',
			image: hit.image || hit.thumbnail || '',
			path: hit.path || hit.url || '#',
		};

		// Handle attributes if they exist
		if (hit.attributes) {
			transformed.attributes = hit.attributes;
		}

		// Handle downloads if they exist
		if (hit.downloads && hit.downloads.length) {
			transformed.downloads = hit.downloads;
		}

		return transformed;
	},

	/**
	 * Render pagination controls
	 * @param {Object} paginationData - { current_page, total_pages, keywords }
	 */
	_renderPagination: function(paginationData) {
		var scope = this;
		var $resultsContainer = $$('search-results');

		// Clean up existing pagination
		if (scope.paginationApp) {
			scope.paginationApp.$destroy();
			scope.paginationApp = null;
		}
		$resultsContainer.find('.pagination').remove();

		if (paginationData.total_pages <= 1) return;

		var model = $.extend({
			query: {},
			current_page: paginationData.current_page
		}, paginationData);

		var $paginationTarget = $('<div />');
		$resultsContainer.append($paginationTarget);

		// Initialize pagination helpers if not already done
		scope._initPaginationHelpers();

		scope.paginationApp = $.app.make(scope.conf.namespace + '-pagination', {
			model: model,
			target: $paginationTarget,
			view: 'search.pagination'
		});

		// Bind pagination events after a short delay to ensure elements exist
		setTimeout(function() {
			scope._bindPaginationEvents();
		}, 100);
	},

	/**
	 * Initialize pagination helper functions
	 */
	_initPaginationHelpers: function() {
		var scope = this;

		// Add the paginate_search helper. If it already exists, this will overwrite it.
		$.view.addHelper('paginate_search', function(current) {
			if (this.val < 2) {
				return false;
			}

			var resp = { pages: [] };
			var total = this.val;
			var keywords = scope._getCurrentKeywords();
			var min = Math.max(1, Math.min(current + (total - current) - 4, current - 2));
			var max = Math.min(total, Math.max(current - (current - 1) + 4, current + 2));
			var i = min;

			while (i <= max) {
				var page = {
					num: i,
					path: '/results?keywords=' + encodeURIComponent(keywords) + (i > 1 ? '&page=' + i : '')
				};

				if (i === current) {
					page.current = true;
				}

				resp.pages.push(page);
				i++;
			}

			if (min > 1) {
				if (min > 2) {
					resp.leading = true;
				}
				resp.first = {
					num: 1,
					path: '/results?keywords=' + encodeURIComponent(keywords)
				};
			}

			if (total > max) {
				if (total > max + 1) {
					resp.trailing = true;
				}
				resp.last = {
					num: total,
					path: '/results?keywords=' + encodeURIComponent(keywords) + '&page=' + total
				};
			}

			if (current > 1) {
				resp.prev = {
					num: current - 1,
					path: '/results?keywords=' + encodeURIComponent(keywords) + (current > 2 ? '&page=' + (current - 1) : '')
				};
			}

			if (current < total) {
				resp.next = {
					num: current + 1,
					path: '/results?keywords=' + encodeURIComponent(keywords) + '&page=' + (current + 1)
				};
			}

			return resp;
		});
	},

	/**
	 * Get current keywords from URL
	 * @returns {String}
	 */
	_getCurrentKeywords: function() {
		return $.routes.uri().query.keywords || '';
	},

	/**
	 * Bind pagination click events
	 */
	_bindPaginationEvents: function() {
		var scope = this;

		// Use event delegation on search-results container
		$$('search-results').off('.pagination').on('click', function(e) {
			// Get the actual clicked element
			var target = e.target;
			var $target = $(target);

			// Check if clicked element or its parent has data-num attribute
			var $clickedLink = $target.closest('[data-num]');

			// Check if we found a pagination link
			if (!$clickedLink.length || !$clickedLink.attr('data-num')) {
				return;
			}

			e.preventDefault();
			e.stopPropagation();

			var num = parseInt($clickedLink.attr('data-num'), 10);
			var keywords = scope._getCurrentKeywords();

			// Fetch new page data
			scope._fetchPageData(keywords, num);

			// Update pagination state
			if (scope.paginationApp) {
				scope.paginationApp.$set('current_page', num);
			}
		}, {
			namespace: 'pagination'
		});
	},

	/**
	 * Fetch data for a specific page
	 * @param {String} keywords
	 * @param {Number} pageNum - 1-indexed page number
	 */
	_fetchPageData: function(keywords, pageNum) {
		var scope = this;
		var algoliaPage = Math.max(0, pageNum - 1); // Convert to 0-indexed

		// Add loading indicator
		var $resultsContainer = $$('search-results');
		$resultsContainer.addClass('-is-fetching');

		// Scroll to top of results
		var top = $resultsContainer.offset().top;
		$.animate.tween($._body, {
			scrollTop: top - 40
		});

		// Update URL without triggering navigation
		var url = '/results?keywords=' + encodeURIComponent(keywords);
		if (pageNum > 1) {
			url += '&page=' + pageNum;
		}

		$.history.go({
			action: false,
			force: true,
			path: url,
			run: false,
			scrollTop: false
		});

		// Fetch new data
		scope.query({
			keywords: keywords,
			context: 'fullPage',
			hitsPerPage: 20,
			page: algoliaPage
		});
	},

	/**
	 * Get result limit (for header search)
	 */
	getLimit: function() {
		return this.conf.limit || 4;
	},

	/**
	 * Transform query results (for header search)
	 */
	transform: function(key, value, data) {
		var scope = this, match;
		if (!scope.app) { return; } // Header app

		if (value) { // `value` is keywords
			var keywordsArray = value.split(/[ ,]/).map(function(k) { return k.trim(); }).filter(function(k) { return k; });
			if (keywordsArray.length > 1) { keywordsArray.unshift(value.replace(/ /g, '[ ,]+')); }
			try { match = new RegExp('(' + keywordsArray.join('|') + ')', 'gi'); } catch (e) { /* ignore */ }
		}
		data.results.forEach(function(el) {
			el.title = el.title && match ? el.title.replace(match, '<b>$&</b>') : el.title;
		});
		scope.populate(value, data); // Populate header app
		if (!value && key !== undefined) { $.set(key, data.results); } // Persist empty search results if key is provided
	},

	/**
	 * Render search options (for header search)
	 */
	populate: function(value, data) {
		var scope = this;
		if (!scope.app) { return; } // Header app

		if (data.total) {
			scope.app.$merge({ message: false, more: data.more, query: value, results: data.results });
			if (scope.active) { // scope.active relates to header dropdown
				if (!scope.visible) {
					$($._body).on('click', function(e) {
						setTimeout(function() {
							if (scope.visible && e.target !== scope.$input[0]) { scope.collapse(); }
						}, 100);
					}, { namespace: scope.app.namespace, once: true });
				}
				scope.show(); // Show header dropdown
			}
		} else {
			scope.app.$merge({ message: scope.active, more: false, results: null });
		}
		if (scope.wait) { // scope.wait relates to header search action
			scope.action();
			delete scope.wait;
		}
	},

	/**
	 * Display results (for header search)
	 */
	show: function() {
		var scope = this;
		scope.visible = true; // For header dropdown
		if (scope.$target.length) scope.$target.addClass('-is-active');
		if (scope.$results && scope.$results.length) scope.$entries = $('li', scope.$results); // In header dropdown
	},

	/**
	 * Hide results (for header search)
	 */
	hide: function() {
		var scope = this;
		scope.visible = false; // For header dropdown
		if (scope.$target.length) scope.$target.removeClass('-is-active');
		if (scope.conf.closed) { scope.conf.closed(); }
	},

	/**
	 * Process available context for action (for header search)
	 */
	action: function() {
		var scope = this;

		if (!scope.pending && scope.$active?.length) { // Active item in header dropdown
			scope.select(scope.$active[0]);

			return;
		}

		$.history.go('/results?keywords=' + scope.$input.val());

		scope.collapse(); // Collapse header dropdown
	},

	/**
	 * Process search result selection (for header search)
	 */
	select: function(el) {
		var scope = this;
		if (!scope.app) return; // Header app needed
		var index = Number(el.dataset.index);
		if (typeof index !== 'number' || isNaN(index)) { return; }
		var path = scope.app.$get('results.' + index + '.path');
		if (path) { $.history.go(path); }
		scope.collapse(); // Collapse header dropdown
	}
});
